export const environment = {
    production: true,
    logErrorInConsole: false,
    environmentName: "production",
    version: require("../../package.json").version,
    httpRequestTimeoutSeconds: 120,
    utcDateFormat: "yyyy-MM-dd HH:mm:ss",
    oauthBaseAPI: "https://api.daumenhoch.app/api/v1/auth/",
    usersAPI: "https://api.daumenhoch.app/api/v1/users/",
    rolesAPI: "https://api.daumenhoch.app/api/v1/roles/",
    organizationsAPI: "https://api.daumenhoch.app/api/v1/organizations/",
    profileAPI: "https://api.daumenhoch.app/api/v1/profile/",
    resetPasswordAPI: "https://api.daumenhoch.app/api/v1/resetpassword/",
    languagesAPI: "https://api.daumenhoch.app/api/v1/languages/",
    smtpMailAccountsAPI: "https://api.daumenhoch.app/api/v1/mailaccounts/",
    mailtemplatesAPI: "https://api.daumenhoch.app/api/v1/mailtemplates/",
    systemLogMessagesAPI: "https://api.daumenhoch.app/api/v1/systemlogs/",
    systemJobPerformancesAPI: "https://api.daumenhoch.app/api/v1/systemjobs/",
    systemResourceSnapshotsAPI: "https://api.daumenhoch.app/api/v1/systemresource/",
    systemErrorsAPI: "https://api.daumenhoch.app/api/v1/systemerrors/",
    crashlogApplicationsAPI: "https://api.daumenhoch.app/api/v1/crashlogapplications/",
    crashlogErrorsAPI: "https://api.daumenhoch.app/api/v1/crashlogerrors/",
    crashlogMessagesAPI: "https://api.daumenhoch.app/api/v1/crashlogmessages/",
    crashlogApiTrackEndpoint: "https://api.daumenhoch.app/api/v1/trackcrashlog/",
    crashlogApiToken: "5c7d91495529584b862ecbcd76cde18e6fab5e55",
    pointsOfInterestAPI: "https://api.daumenhoch.app/api/v1/pointsofinterest/",
    categoriesAPI: "https://api.daumenhoch.app/api/v1/categories/"
};
